var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin",
    clipPath: "url(#clip0_135_1433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Linkedin_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 30 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 38.3333C30.1252 38.3333 38.3333 30.1252 38.3333 20C38.3333 9.87478 30.1252 1.66667 20 1.66667C9.87478 1.66667 1.66667 9.87478 1.66667 20C1.66667 30.1252 9.87478 38.3333 20 38.3333ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2688 22.7068C17.2688 21.184 17.2688 19.7701 17.2688 18.2474C17.3776 16.2896 18.4652 15.3107 20.2055 16.0721C21.0756 16.3984 21.6194 16.5071 22.272 16.1808C23.9035 15.3107 25.3174 15.9633 26.8402 16.5071C27.819 16.8334 28.3629 17.5948 28.6892 18.5737C29.5593 21.4016 29.5593 24.2295 29.4506 27.0574C29.4506 27.8187 29.1242 28.3626 28.2541 28.4713C28.0366 28.4713 27.9278 28.4713 27.7103 28.5801C24.6649 29.1239 24.3385 28.9064 24.6648 25.861C24.7736 24.5558 24.9911 23.2506 24.6648 21.9454C24.4473 21.2928 24.2298 20.5314 23.3597 20.4227C22.5983 20.3139 22.0545 20.8577 21.6194 21.4016C21.1844 21.9454 21.0756 22.598 21.0756 23.3593C21.0756 24.447 21.0756 25.4259 21.0756 26.5136C21.0756 28.6889 20.9668 28.7976 19.0091 28.6889C17.16 28.6889 17.16 28.6888 17.16 26.8398C17.2688 25.5347 17.2688 24.1207 17.2688 22.7068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.2868 22.4893C11.2868 20.9666 11.2868 19.5526 11.2868 18.0299C11.2868 16.7247 12.0481 16.5072 13.1358 16.3984C14.3322 16.3984 14.5497 17.051 14.5497 18.0299C14.7672 20.8578 14.7673 23.6857 14.6585 26.5136C14.6585 27.4925 14.6585 28.689 13.1358 28.689C11.8306 28.7977 11.178 28.2539 11.178 26.9487C11.178 25.426 11.178 23.7945 11.178 22.2718C11.178 22.4893 11.2868 22.4893 11.2868 22.4893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.2656 10.4165C13.8971 10.4165 14.7673 11.0691 14.7673 12.048C14.7673 13.2444 13.3533 14.6584 12.2656 14.6584C11.178 14.6584 10.4167 13.7882 10.4167 12.5918C10.5254 11.1779 11.178 10.4165 12.2656 10.4165Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_1433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.5397eb323930d98c77d0e65bad6d38af.svg";
export { ForwardRef as ReactComponent };